// extracted by mini-css-extract-plugin
export default {"container":"Card_container__DbXh1","fadeIn":"Card_fadeIn__RpSBj","content":"Card_content__3+f8H","title":"Card_title__A6GVy","description":"Card_description__jyadU"};